  function sucss(t) {

       console.log('asdasd123123123');
    
    var e = jQuery(t),
        i = jQuery("<div>").append(e),
        n = i.find(".onecart").text();
    console.log(i), jQuery(".onecart").html(n),jQuery(".twocart").html(n), jQuery(".cart-btn").html("<span class='fa fa-shopping-bag'></span><span>" + n + "</span>");
    var o = i.find(".g-side-cart").html();
  var cov = i.find(".g-covid-bar").html();
    
  jQuery(".g-covid-bar").html(cov),
    jQuery(".g-side-cart").html(o),
        setTimeout(function(){
		if($('.goals-reached').length > 0){
        console.log('reached');
        $('.completionWording').text('Your order qualifies for FREE Express Shipping - Australia ONLY');
        $('.completionWording').removeClass("hidden");
        $('.cupb__single-goal').removeClass("hidden");
      }
      }, 50),
     
        jQuery("body").addClass("g-cart-open"),
        jQuery(".g-cart-close").on("click", function () {
            jQuery("body").removeClass("g-cart-open");
        }),
        jQuery(".g-qty-option .qtybtn").on("click", function () {
            var t,
                e = jQuery(this),
                i = e.parent(".g-qty-option").find("input").val();
            (t = e.hasClass("g-btn-plus") ? parseFloat(i) + 1 : 0 <= i ? parseFloat(i) - 1 : 1), e.parent().find("input").val(t);
        }),
        jQuery(".g-cart-in .g-qty-option .qtybtn").on("click", function (t) {
            t.preventDefault();
            var e = jQuery(this).parent(".g-qty-option").find("input").val(),
                i = jQuery(this).parents(".single").attr("data-line");
            jQuery(this).parents(".single").addClass("is-loading"), jQuery.ajax({ type: "POST", url: "/cart/change.js", dataType: "json", data: "quantity=" + e + "&line=" + i, success: Shopify.onSuccess, error: Shopify.onError });
          
        });
  function addItem(t) {
            jQuery.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", data: jQuery("#" + t).serialize(), success: Shopify.onSuccess, error: Shopify.onError });
        }
    jQuery('.custom-radios input[type="radio"]').change(function(){
    var value = jQuery( this ).val();
   
     
  jQuery(this).parents('.custom-radios').find("input.ori").val(value);
     
   
});
  jQuery(".add_to_cart_button").each(function () {
                jQuery(this).click(function (t) {
                  t.preventDefault();
                   jQuery('.ual').addClass("is-loading");
                  jQuery(this).parent("form").parent(".cart__item-cta").parent(".cart__item-info").parent(".g-cart-item-upsell").addClass("is-loading");
            addItem(jQuery(this).parents("form").attr("id"));
                });
            });
   jQuery('.cart__upsell-btn').click(function() {
    jQuery(this).next('.custom-radios').show();
    jQuery(this).hide();
  
  });
  jQuery('.c-radio input[name="id"]').change(function() {
 
        jQuery(this).parent(".c-radio").parent(".custom-radios").parent("form").parent(".cart__item-cta").parent(".cart__item-info").parent(".g-cart-item-upsell").addClass("is-loading");
      jQuery(this).parent(".c-radio").parent(".custom-radios").find('.maktit').trigger( "click" );
       
       
      });
 jQuery(".add_to_cart_buttona").each(function () {
   
                jQuery(this).click(function (t) {
                  t.preventDefault();
                   jQuery(this).addClass("is-loading");
                  t.preventDefault();
                   jQuery('.custom-radio').addClass("is-loading");
            var form = jQuery(this).parent(".custom-radios").find('input[name="id"]:checked').val();
                 
                   jQuery.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", data: "quantity=1&id=" + form, success: Shopify.onSuccess, error: Shopify.onError });
      
                });
            });
     jQuery(".rem").on('click', function (e) {
      e.preventDefault();
      
      var line = jQuery(this).parents('.qr-wrap').parents('.single').attr("data-line");
           jQuery(this).parents('.single').addClass("is-loading");
           
 jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
         data: 'quantity='+0+'&line='+line,
       success: Shopify.onSuccess,
        error: Shopify.onError
      });
      
      

   });
  jQuery(".atcamadscc").on("click", function () {
  window.location = '/cart';
});
   $('.checkoutbtn').on('click',function(){

                   console.log('asddadad');
                    window.location.href = "/checkout";
                }); 
    if($('.goals-reached').length > 0){
            console.log('reached');
            $('.completionWording').text('Your order qualifies for FREE Express Shipping - Australia ONLY');
            $('.completionWording').removeClass("hidden");
            $('.cupb__single-goal').removeClass("hidden");
          }
   
  // refresh OnVoard aov progress bar
  setTimeout(() => {
    OnVoard('aov_progress_bar', 'reload');
  }, 200);
}
function quantityup() {
    jQuery(".g-qty-option .QuantitySelector__Button").on("click", function () {
        var t,
            e = jQuery(this),
            i = e.parent(".g-qty-option").find("input").val();
        (t = e.hasClass("g-btn-plus") ? parseFloat(i) + 1 : 0 <= i ? parseFloat(i) - 1 : 1), e.parent().find("input").val(t);
    });
}
jQuery(function() {
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
  });
});
                   jQuery( "#triger" ).click(function() {
  jQuery( "#AddToCart" ).click();
});
       
//        jQuery(document).ready(function(){
//      jQuery(document).bind("contextmenu",function(e){
//         return false;
//     });
// });
    jQuery(document).ready(function() {
      if($('.goals-reached').length > 0){
        console.log('reached');
        $('.completionWording').text('Your order qualifies for FREE Express Shipping - Australia');
        $('.completionWording').removeClass("hidden");
        $('.cupb__single-goal').removeClass("hidden");
      }
  jQuery('.cart__upsell-btn').click(function() {
    jQuery(this).next('.custom-radios').show();
    jQuery(this).hide();
  
  });
        jQuery('.c-radio input[name="id"]').change(function() {
 jQuery(this).parent(".c-radio").parent(".custom-radios").parent("form").parent(".cart__item-cta").parent(".cart__item-info").parent(".g-cart-item-upsell").addClass("is-loading");
       
      jQuery(this).parent(".c-radio").parent(".custom-radios").find('.maktit').trigger( "click" );
       
       
      });
        
       jQuery(".add_to_cart_buttona").each(function () {
         
                jQuery(this).click(function (t) {
                  jQuery(this).addClass("is-loading");
                  t.preventDefault();
                   jQuery('.custom-radio').addClass("is-loading");
            var form = jQuery(this).parent(".custom-radios").find('input[name="id"]:checked').val();
                 
                   jQuery.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", data: "quantity=1&id=" + form, success: Shopify.onSuccess, error: Shopify.onError });
      
                });
            });
   
       jQuery(".rem").on('click', function (e) {
      e.preventDefault();
      
      var line = jQuery(this).parents('.qr-wrap').parents('.single').attr("data-line");
           jQuery(this).parents('.single').addClass("is-loading");
           
 jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
         data: 'quantity='+0+'&line='+line,
       success: Shopify.onSuccess,
        error: Shopify.onError
      });
      
      

   });
       
});  
  
 
    jQuery(document).ready(function () {
        function addItem(t) {
            jQuery.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", data: jQuery("#" + t).serialize(), success: Shopify.onSuccess, error: Shopify.onError });
        }
        jQuery(".AddToCart").click(function (t) {
            t.preventDefault(), jQuery(this).prop("disabled", !0), addItem(jQuery(this).parents("form").attr("id"));
        }),
            jQuery('.custom-radios input[type="radio"]').change(function(){
    var value = jQuery( this ).val();
   
     
  jQuery(this).parents('.custom-radios').find("input.ori").val(value);
     
   
});
            jQuery(".add_to_cart_button").each(function () {
                jQuery(this).click(function (t) {
                   jQuery('.ual').addClass("is-loading");
                  jQuery(this).parent("form").parent(".cart__item-cta").parent(".cart__item-info").parent(".g-cart-item-upsell").addClass("is-loading");
                     addItem(jQuery(this).parents("form").attr("id"));
                });
            }),
            (Shopify.onSuccess = function () {
                jQuery(".AddToCart").removeAttr("disabled");
                parseInt(jQuery('[name="quantity"]').val(), 10);
                jQuery.ajax({
                    type: "GET",
                    url: "/cart",
                    dataType: "html",
                    success: function (t) {
                      
                        sucss(t);
                    },
                });
            }),
            (Shopify.onError = function (XMLHttpRequest, textStatus) {
                console.log("errorerror");
                var data = eval("(" + XMLHttpRequest.responseText + ")");
                data.message ? alert(data.message + "(" + data.status + "): " + data.description) : alert("Error : " + Shopify.fullMessagesFromErrors(data).join("; ") + "."), jQuery(".addtocart").removeAttr("disabled");
            }),
            (Shopify.fullMessagesFromErrors = function (t) {
                var n = [];
                return (
                    jQuery.each(t, function (i, t) {
                        jQuery.each(t, function (t, e) {
                            n.push(i + " " + e);
                        });
                    }),
                    n
                );
            });
    }),
    quantityup(),
    jQuery(document).ready(function () {
  jQuery(".g-qty-option .qtybtn").on("click", function () {
            var t,
                e = jQuery(this),
                i = e.parent(".g-qty-option").find("input").val();
            (t = e.hasClass("g-btn-plus") ? parseFloat(i) + 1 : 0 <= i ? parseFloat(i) - 1 : 1), e.parent().find("input").val(t);
        }),
        jQuery(".g-cart-in .g-qty-option .qtybtn").on("click", function (t) {
    		console.log('test');
            t.preventDefault();
            var e = jQuery(this).parent(".g-qty-option").find("input").val(),
                i = jQuery(this).parents(".single").attr("data-line");
            jQuery(this).parents(".single").addClass("is-loading"), jQuery.ajax({ type: "POST", url: "/cart/change.js", dataType: "json", data: "quantity=" + e + "&line=" + i, success: Shopify.onSuccess, error: Shopify.onError });
        });
  

  
    });
    jQuery(".g-cart-open").on("click", function () {
                jQuery("body").addClass("g-cart-open");
      //jQuery('.iCartBtnToggle').click();
      console.log('asdasda12312321');
      if($('.goals-reached').length > 0){
        console.log('reached');
        $('.completionWording').text('Your order qualifies for FREE Express Shipping - Australia');
        $('.completionWording').removeClass("hidden");
        $('.cupb__single-goal').removeClass("hidden");
      }
                $('.checkoutbtn').on('click',function(){

                   console.log('asddadad');
                    window.location.href = "/checkout";
                });
            }),
                jQuery(".g-cart-close").on("click", function () {
                    jQuery("body").removeClass("g-cart-open");
                });

var currentemt ;

jQuery(document).on('click', '.custom-add-size', function(){ 

//jQuery(".custom-add-size").click(function(){
  var sizevl = jQuery(this).text();
  currentemt = jQuery(this);
  var sizeid = jQuery(this).attr('data-sizeid');
  jQuery(this).parent().parent().find('.product-select').val(sizeid);
  jQuery(this).parent().parent().find('.product-select').attr('data-variant-title',sizevl);  
  jQuery(this).parent().parent().find('.custom-add-radio').val(sizevl);
  jQuery(this).parent().parent().find('.listadd').trigger( "click" );
  
}); 

jQuery(document).on('click', '.listadd', function(){ 
//jQuery(".listadd").click(function(){
  var form      = jQuery(this).parents('form');

  jQuery('.product-add .add').val('Adding...');
   currentemt.parent().parent().prev('.check-wrap').css('display','block');
   currentemt.parent().parent().prev('.check-wrap').find('.checkmark').addClass('fadeIn');
   jQuery('.available').css('pointer-events','none');
     setTimeout(function(){
        currentemt.parent().parent().prev('.check-wrap').find('.checkmark').removeClass('fadeIn');
   	    currentemt.parent().parent().prev('.check-wrap').css('display','none');
        jQuery('.available').css('pointer-events','visible');
    }, 3000);
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: false,
    data: form.serialize(),
    dataType: 'json',
    success: Shopify.onSuccess,
        error: Shopify.onError,
    cache: false
  });

}); 
jQuery(".atcamadscc").on("click", function () {

  window.location = '/cart';
});